<template>
  <div class="container-fluid">
    <AlertaMsj :alerta-msj="alertaMsj" />
    <div class="row">
      <div :class="['col-12', $route.params.userId ? 'col-lg-8' : null]">
        <header class="h3-responsive text-center font-weight-bold my-3 ">
          Solicitudes Modulo {{ $route.params.modulo }}
        </header>
        <div class="card-input-type">
          <header class="card-label">
            Filtros de búsqueda
          </header>
          <form
            class="d-justify-center"
            @submit.prevent="filterAndSearch"
          >
            <div class="options">
              <div class="our-radio mb-2 mb-lg-0">
                <input
                  id="radio-sm-op1"
                  v-model="filterBy"
                  type="radio"
                  name="radio"
                  value="date"
                >
                <label
                  for="radio-sm-op1"
                  class="our-radio-label"
                >
                  Fecha
                </label>
                <mdb-input
                  v-model="searchBy.date"
                  type="date"
                  label="Fecha"
                  class="my-1 ml-2 d-inline-block input-mb-0
                    w-card-input outline-date"
                  valid-feedback=""
                  invalid-feedback="Debe seleccionar una
                  fecha válida"
                  outline
                  @change="filterBy = 'date'"
                />
              </div>
              <div class="our-radio mb-2 mb-lg-0">
                <input
                  id="radio-sm-op2"
                  v-model="filterBy"
                  type="radio"
                  name="radio"
                  value="status"
                >
                <label
                  for="radio-sm-op2"
                  class="our-radio-label"
                >
                  Estatus
                </label>
                <div
                  class="w-card-input my-1 ml-2
                    md-form md-outline outline-select"
                >
                  <select
                    id="genderSelect"
                    v-model="searchBy.status"
                    class="custom-select"
                    @change="filterBy = 'status'"
                  >
                    <option
                      class="d-none"
                      disabled
                      value=""
                    >
                      Seleccione
                    </option>
                    <option value="Preaprobado">
                      Preaprobado
                    </option>
                    <option value="emailConfirmation">
                      Sin confirmar email
                    </option>
                  </select>
                  <div class="valid-feedback" />
                  <div class="invalid-feedback">
                    Debe seleccionar una opción
                  </div>
                </div>
              </div>
              <div class="our-radio mb-2 mb-lg-0">
                <input
                  id="radio-sm-op3"
                  v-model="filterBy"
                  type="radio"
                  name="radio"
                  value="name"
                >
                <label
                  for="radio-sm-op3"
                  class="our-radio-label"
                >
                  Nombre
                </label>
                <mdb-input
                  v-model="searchBy.name"
                  class="my-1 ml-2 d-inline-block input-mb-0 w-card-input"
                  label=""
                  invalid-feedback="Debe ingresar un nombre válido"
                  outline
                  @change="filterBy = 'name'"
                />
              </div>
            </div>
            <mdb-btn
              type="submit"
              color="primary"
              class="px-3"
              text="danger"
              title="Buscar"
              :disabled="btnDisabled.search"
            >
              <font-awesome-icon
                v-if="btnDisabled.search"
                icon="circle-notch"
                spin
                size="lg"
                class="mr-1"
              />
              <font-awesome-icon
                v-else
                icon="search"
                size="lg"
                class="mr-1"
              />
              Buscar
            </mdb-btn>
            <mdb-btn
              type="button"
              class="btn-own-flat px-3"
              dark-waves
              flat
              :disabled="btnDisabled.allRequest"
              @click="searchAllDoctorRequest"
            >
              Todas las Solicitudes
              <font-awesome-icon
                v-if="btnDisabled.allRequest"
                icon="circle-notch"
                class="ml-1"
                spin
                size="lg"
              />
            </mdb-btn>
          </form>
        </div>
        <ul class="row card-list">
          <li
            v-for="(solicitud, index) in solicitudes"
            :key="solicitud.id"
            class="card-size-spacing"
          >
            <TarjetaResultadoMedico
              :doctor="solicitud.doctor"
              :status="solicitud.status"
              :fecha="solicitud.createdAt"
              class="card p-2"
            >
              <template v-slot:botones>
                <div class="botones">
                  <div class="our-checkbox big-icon-style">
                    <input
                      :id="`checkbx-solmod-${index}`"
                      v-model="usersId"
                      type="checkbox"
                      :value="solicitud.id"
                    >
                    <label
                      :for="`checkbx-solmod-${index}`"
                      class="mb-0"
                    />
                  </div>
                  <div>
                    <router-link
                      :to="{name:'SolicitudMedico',
                            params:{userId: solicitud.id}}"
                    >
                      <mdb-btn
                        class="text-nowrap"
                        color="info"
                        icon="plus"
                        icon-right
                        size="md"
                        type="button"
                      >
                        Ver
                      </mdb-btn>
                    </router-link>
                  </div>
                </div>
              </template>
            </TarjetaResultadoMedico>
          </li>
        </ul>
        <!-- agregar transition de preferencia -->
        <!-- <transition
          name="slide-fade"
          :duration="1000"
        > -->
        <template v-if="usersId.length">
          <transition
            name="slide-fade"
            :duration="500"
          >
            <font-awesome-icon
              v-if="btnDisabled.deleteUsers"
              :class="['eliminar-flotante',
                       $route.params.userId ? 'right-af' : null]"
              icon="trash"
              spin
              size="sm"
              title="Cargando..."
            />
            <font-awesome-icon
              v-else
              :class="['eliminar-flotante',
                       $route.params.userId ? 'right-af' : null]"
              icon="trash"
              size="sm"
              title="Eliminar usuarios"
              @click="validarEliminarUsuarios"
            />
          </transition>
          <transition
            name="slide-fade"
            :duration="500"
          >
            <font-awesome-icon
              v-if="btnDisabled.denyAccess"
              :class="['denegacion-flotante',
                       $route.params.userId ? 'right-af' : null]"
              icon="ban"
              spin
              size="lg"
              title="Cargando..."
            />
            <font-awesome-icon
              v-else
              :class="['denegacion-flotante',
                       $route.params.userId ? 'right-af' : null]"
              icon="ban"
              size="lg"
              title="Negar solicitudes"
              @click="validarNegarSolicitud"
            />
          </transition>
          <transition
            name="slide-fade"
            :duration="500"
          >
            <font-awesome-icon
              v-if="btnDisabled.grantAccess"
              :class="['aprobacion-flotante',
                       $route.params.userId ? 'right-af' : null]"
              icon="circle-notch"
              spin
              size="lg"
              title="Cargando..."
            />
            <font-awesome-icon
              v-else
              :class="['aprobacion-flotante',
                       $route.params.userId ? 'right-af' : null]"
              icon="check-circle"
              size="lg"
              title="Aprobación"
              @click="grantAccess"
            />
          </transition>
        </template>
      </div>
      <transition
        name="slide-fade"
        :duration="1000"
      >
        <router-view @limpiarSolicitudes="limpiarSolicitudes($event)" />
      </transition>
    </div>
    <!-- Modal confirmación rechazar -->
    <mdb-modal
      centered
      elegant
      :show="showConfirmation"
      @close="showConfirmation = false; esNegarSolicitud = false"
    >
      <mdb-modal-header>
        <mdb-modal-title>
          Se requiere confirmación
        </mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <p class="text-center px-4 px-sm-5">
          {{
            usersId.length > 1
              ? `Se ${esNegarSolicitud
                ? 'negarán las solicitudes'
                : 'eliminarán los doctores'}`
              : `Se ${esNegarSolicitud
                ? 'negará la solicitud'
                : 'eliminará el doctor'}`
          }}
          en su totalidad.
          <span
            v-if="esNegarSolicitud"
            class="d-block mt-2 font-weight-bold"
          >
            ¿Estás seguro que deseas negarl{{
              usersId.length > 1
                ? 'as'
                : 'a'
            }}?
          </span>
          <span
            v-else
            class="d-block mt-2 font-weight-bold"
          >
            ¿Estás seguro que deseas eliminar{{
              usersId.length > 1
                ? ' los doctores'
                : ' el doctor'
            }}?
          </span>
        </p>
        <div class="row justify-content-around">
          <mdb-btn
            flat
            waves
            :icon="btnDisabled.denyAccess ? 'circle-notch' : 'times'"
            :icon-class="btnDisabled.denyAccess ? 'fa-spin' : ''"
            :disabled="btnDisabled.denyAccess"
            class="col-auto btn-bordeado px-4"
            @click="showConfirmation = false; esNegarSolicitud = false"
          >
            No
          </mdb-btn>
          <mdb-btn
            color="danger"
            :icon="btnDisabled.denyAccess ? 'circle-notch' : 'check'"
            :icon-class="btnDisabled.denyAccess ? 'fa-spin' : ''"
            :disabled="btnDisabled.denyAccess"
            class="col-auto px-4"
            @click="esNegarSolicitud ? denyAccess() : deleteUsers()"
          >
            Si
          </mdb-btn>
        </div>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
import {
  mdbInput,
  mdbBtn,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle,
} from 'mdbvue';
import gql from 'graphql-tag';
import TarjetaResultadoMedico from '../components/TarjetaResultadoMedico.vue';
import AlertaMsj from '@/components/AlertaMsj.vue';
import usersAskingAccessToGql from '@/graphql/usersAskingAccessTo.gql';
import usersFilterStatusGql from '@/graphql/usersFilterStatus.gql';
import usersFilterDateGql from '@/graphql/usersFilterDate.gql';
import usersFilterFullnameGql from '@/graphql/usersFilterFullname.gql';
import grantAccessGql from '@/graphql/grantAccess.gql';
import denyAccessGql from '@/graphql/denyAccess.gql';
import deleteUsersGql from '@/graphql/deleteUsers.gql';
import userDoctorFragmentGql from '@/graphql/userDoctorFragment.gql';

export default {
  name: 'SolicitudesModulo',
  components: {
    mdbInput,
    mdbBtn,
    TarjetaResultadoMedico,
    AlertaMsj,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalTitle,
  },
  data() {
    return {
      filterBy: '',
      esNegarSolicitud: false,
      searchBy: {
        name: '',
        status: '',
      },
      alertaMsj: {
        content: '',
      },
      usersId: [],
      btnDisabled: {
        search: false,
        grantAccess: false,
        denyAccess: false,
        allRequest: false,
        deleteUsers: false,
      },
      // Modal
      showConfirmation: false,
    };
  },
  methods: {
    validarEliminarUsuarios() {
      this.usersId.length
        ? this.showConfirmation = !this.showConfirmation
        : this.alertaMsj = {
          content: 'Selecciona un doctor antes de eliminarlo',
          type: 'warning',
        };
    },
    validarNegarSolicitud() {
      this.esNegarSolicitud = true;
      this.usersId.length
        ? this.showConfirmation = !this.showConfirmation
        : this.alertaMsj = {
          content: 'Selecciona un doctor antes de rechazar',
          type: 'warning',
        };
    },
    limpiarSolicitudes(ids) {
      if (!ids.length) return;
      this.solicitudes = this.solicitudes.filter((e)=> {
        return !ids.includes(e.id);
      });
    },
    filterAndSearch() {
      this.alertaMsj.content = '';
      if (!this.filterBy) {
        return this.alertaMsj = {
          content: 'Selecciona un método para filtrar',
          type: 'warning',
        };
      }
      if (this.filterBy == 'date') {
        if (!this.searchBy.date) {
          return this.alertaMsj = {
            content: 'Indica una fecha',
            type: 'warning',
          };
        }
        this.btnDisabled.search = true;
        this.$apollo.query({
          query: gql`${usersFilterDateGql}
            ${userDoctorFragmentGql}`,
          variables: {
            module: this.$route.params.modulo,
            date: {
              year: new Date(this.searchBy.date).getFullYear(),
              month: new Date(this.searchBy.date).getMonth()+1,
              day: new Date(this.searchBy.date).getDate(),
            },
          },
          update: (data) => data.User,
          fetchPolicy: 'no-cache',
        }).then((res) => {
          this.solicitudes = res.data.User;
          this.btnDisabled.search = false;
        }).catch((error) => {
          this.btnDisabled.search = false;
          return this.alertaMsj = {
            content: 'Hubo un error al filtrar por fecha',
            type: 'danger',
          };
        });
      }
      if (this.filterBy == 'status') {
        if (!this.searchBy.status) {
          return this.alertaMsj = {
            content: 'Selecciona un estado',
            type: 'warning',
          };
        }
        this.btnDisabled.search = true;
        this.$apollo.query({
          query: gql`${usersFilterStatusGql}
            ${userDoctorFragmentGql}`,
          variables: {
            module: this.$route.params.modulo,
            status: this.searchBy.status,
          },
          update: (data) => data.User,
          fetchPolicy: 'no-cache',
        }).then((res) => {
          this.solicitudes = res.data.User;
          this.btnDisabled.search = false;
        }).catch((error) => {
          this.btnDisabled.search = false;
          return this.alertaMsj = {
            content: 'Hubo un error al filtrar por estado',
            type: 'danger',
          };
        });
      }
      if (this.filterBy == 'name') {
        if (!this.searchBy.name) {
          return this.alertaMsj = {
            content: 'Escriba un nombre en el campo',
            type: 'warning',
          };
        }
        if (this.searchBy.name.length < 5) {
          return this.alertaMsj = {
            content: 'El nombre debe tener como mínimo 5 caracteres',
            type: 'warning',
          };
        }
        this.btnDisabled.search = true;
        this.$apollo.query({
          query: gql`${usersFilterFullnameGql}
            ${userDoctorFragmentGql}`,
          variables: {
            module: this.$route.params.modulo,
            fullname: this.searchBy.name,
          },
          update: (data) => data.usersAskingAccessTo,
          fetchPolicy: 'no-cache',
        }).then((res) => {
          this.solicitudes = res.data.usersAskingAccessTo;
          this.btnDisabled.search = false;
        }).catch((error) => {
          this.btnDisabled.search = false;
          return this.alertaMsj = {
            content: 'Hubo un error al filtrar por nombre',
            type: 'danger',
          };
        });
      }
    },
    grantAccess() {
      if (this.btnDisabled.grantAccess) return;
      if (this.usersId.length < 1) {
        return this.alertaMsj = {
          content: 'Selecciona un doctor antes de aprobar',
          type: 'warning',
        };
      }
      this.btnDisabled.grantAccess = true;
      this.$apollo.mutate({
        mutation: gql`${grantAccessGql}`,
        variables: {
          usersId: this.usersId,
          module: this.$route.params.modulo,
        },
      }).then((res) => {
        const msg = res.data.grantAccess.msg;
        switch (msg) {
          case 'success':
            this.solicitudes = this.solicitudes.filter((e)=> {
              return !this.usersId.includes(e.id);
            });
            this.alertaMsj = {
              content: 'El médico ha sido aprobado satisfactoriamente',
              type: 'success',
            };
            break;
          default:
            this.alertaMsj = {
              content: 'Hubo un error al aprobar al médico',
              type: 'danger',
            };
            break;
        }
        this.btnDisabled.grantAccess = false;
      }).catch((error) => {
        this.btnDisabled.grantAccess = false;
        return this.alertaMsj = {
          content: 'Hubo un error'+
            ' al enviar la aprobación del médico',
          type: 'danger',
        };
      });
    },
    denyAccess() {
      if (this.btnDisabled.denyAccess) return;
      this.btnDisabled.denyAccess = true;
      this.$apollo.mutate({
        mutation: gql`${denyAccessGql}`,
        variables: {
          usersId: this.usersId,
          module: this.$route.params.modulo,
        },
      }).then((res) => {
        const msg = res.data.denyAccess.msg;
        switch (msg) {
          case 'success':
            this.solicitudes = this.solicitudes.filter((e)=> {
              return !this.usersId.includes(e.id);
            });
            this.alertaMsj = {
              content: 'El médico ha sido rechazado satisfactoriamente',
              type: 'success',
            };
            this.showConfirmation = false;
            break;
          default:
            this.alertaMsj = {
              content: 'Hubo un error al rechazar al médico',
              type: 'danger',
            };
            break;
        }
        this.btnDisabled.denyAccess = false;
      }).catch((error) => {
        this.btnDisabled.denyAccess = false;
        return this.alertaMsj = {
          content: 'Hubo un error'+
            ' al enviar la denegación del médico',
          type: 'danger',
        };
      });
    },
    deleteUsers() {
      if (this.btnDisabled.denyAccess) return;
      this.btnDisabled.denyAccess = true;
      this.btnDisabled.deleteUsers = true;
      this.$apollo.mutate({
        mutation: gql`${deleteUsersGql}`,
        variables: {
          usersId: this.usersId,
        },
      }).then((res) => {
        const msg = res.data.deleteUsers.msg;
        switch (msg) {
          case 'success':
            this.solicitudes = this.solicitudes.filter((e)=> {
              return !this.usersId.includes(e.id);
            });
            this.alertaMsj = {
              content: 'El doctor ha sido eliminado satisfactoriamente',
              type: 'success',
            };
            this.showConfirmation = false;
            break;
          default:
            this.alertaMsj = {
              content: 'Hubo un error al eliminar médico',
              type: 'danger',
            };
            break;
        }
        this.btnDisabled.deleteUsers = false;
        this.btnDisabled.denyAccess = false;
      }).catch((error) => {
        this.btnDisabled.denyAccess = false;
        this.btnDisabled.deleteUsers = false;
        return this.alertaMsj = {
          content: 'Hubo un error'+
            ' al enviar la solicitud de eliminar médico',
          type: 'danger',
        };
      });
    },
    searchAllDoctorRequest() {
      this.filterBy = '';
      this.searchBy = {
        name: '',
        status: '',
      };
      this.btnDisabled.allRequest = true;
      this.$apollo.query({
        query: gql`${usersAskingAccessToGql}
          ${userDoctorFragmentGql}`,
        variables: {
          module: this.$route.params.modulo,
        },
        update: (data) => data.User,
        fetchPolicy: 'no-cache',
      }).then((res) => {
        this.solicitudes = res.data.User;
        this.btnDisabled.allRequest = false;
      }).catch((error) => {
        this.btnDisabled.allRequest = false;
        return this.alertaMsj = {
          content: 'Hubo un error'+
            ' al refrescar doctores en general',
          type: 'danger',
        };
      });
    },
  },
  apollo: {
    solicitudes() {
      return {
        query: gql`${usersAskingAccessToGql}
          ${userDoctorFragmentGql}`,
        variables: {
          module: this.$route.params.modulo,
        },
        update: (data) => data.User,
        fetchPolicy: 'no-cache',
      };
    },
  },
};
</script>
<style lang="scss">
  .card-input-type {
    margin-bottom: 1rem;

    .card-label {
      font-weight: 600;
      margin: .75rem auto;
      text-align: center;
    }

    .d-justify-center {
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
    }

    .options {
      display: flex;
      flex-direction: column;

      @media (min-width: 400px) and (max-width: 991px) {
        width: 90%;
      }

      @media (min-width: 992px) {
        flex-direction: row;
      }
    }

    .our-radio label.our-radio-label {
      @media (min-width: 385px) {
        margin-bottom: 0;
      }
    }

    .w-card-input {
      width: 100%;

      @media (min-width: 400px) {
        width: 70%;
      }
      @media (min-width: 500px) {
        width: 78%;
      }
      @media (min-width: 600px) {
        width: 82%;
      }
      @media (min-width: 768px) and (max-width: 991px) {
        width: 86%;
      }
      @media (min-width: 992px) {
        width: 194px;
      }
    }

    .btn-own-flat {
      box-shadow: 0 0 1px $grey-darken-1;
      transition: box-shadow .5s ease;

      &:hover {
        box-shadow: 0 0 1.5px $grey-darken-1  !important;
      }
    }
  }

  .card-list {
    justify-content: space-around;
    list-style: none;

    .card-size-spacing {
      margin: .5rem 15px;
      width: 290px;
    }

    .card.p-2 {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .botones {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      .our-checkbox.big-icon-style label::before {
        font-size: 2.5rem;
      }
    }
  }

  .aprobacion-flotante {
    background-color: white;
    border-radius: 100%;
    bottom: 1rem;
    color: $success-color;
    cursor: pointer;
    font-size: 3rem;
    position: fixed;
    right: 1rem;
    transition: right .8s ease;

    &:hover {
      box-shadow: 0 2px 6px $grey-base;
    }

    @media (min-width: 1300px) {
      bottom: 2rem;
      right: 5%;
    }

    @media (min-width: 1500px) {
      right: 9%;
    }

    @media (min-width: 1700px) {
      right: 14%;
    }

    @media (min-width: 2000px) {
      right: 21%;
    }

    &.right-af {
      @media (min-width: 992px) {
        right: calc(50% - 16%);
      }
    }
  }

  .denegacion-flotante {
    border-radius: 100%;
    bottom: 1rem;
    color: $warning-color;
    cursor: pointer;
    font-size: 3rem;
    position: fixed;
    right: 5rem;
    transition: right .8s ease;

    &:hover {
      box-shadow: 0 2px 6px $grey-base;
    }

    @media (min-width: 1300px) {
      bottom: 2rem;
      right: 10%;
    }

    @media (min-width: 1500px) {
      right: 18%;
    }

    @media (min-width: 1700px) {
      right: 28%;
    }

    @media (min-width: 2000px) {
      right: 42%;
    }

    &.right-af {
      @media (min-width: 992px) {
        right: calc(60% - 16%);
      }
    }
  }

  .eliminar-flotante {
    border-radius: 100%;
    bottom: 1rem;
    color: $danger-color;
    cursor: pointer;
    font-size: 3rem;
    position: fixed;
    right: 9rem;
    transition: right .8s ease;

    &:hover {
      box-shadow: 0 2px 6px $grey-base;
    }

    @media (min-width: 1300px) {
      bottom: 2rem;
      right: 15%;
    }

    @media (min-width: 1500px) {
      right: 28%;
    }

    @media (min-width: 1700px) {
      right: 40%;
    }

    @media (min-width: 2000px) {
      right: 60%;
    }

    &.right-af {
      @media (min-width: 992px) {
        right: calc(70% - 16%);
      }
    }
  }
  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
    transition: all .8s;
  }
  .slide-fade-leave-active {
    transition: all .8s;
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(5em);
    opacity: 0;
  }
</style>
